import React, { useEffect, useState } from "react";
import { Modal, Divider, ConfigProvider, Input, Checkbox, Radio, Pagination } from "antd";
import useUserStore from "../../stores/store";
import CustomInputNumberV2 from "../CustomInputNumberV2";
import CustomInputNumber from "../CustomInputNumber";

function AddSetFoodMenuModal({ openModal, records, selectedItems, setSelectedItems }) {

  const { restaurantId } = useUserStore();
  const [relatedItems, setRelatedItems] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    if (openModal) {
      setRelatedItems(records.comboFoods);
      setSelectedItems((prevSelectedItems) => {
        const updatedItems = { ...prevSelectedItems };
        records.comboFoods.forEach((food) => {
          if (selectedItems[food._id]) {
            updatedItems[food._id] = selectedItems[food._id];
          }
        });
        return updatedItems;
      });
    }
  }, [openModal, records.comboFoods, setSelectedItems]);

  // 🔥 FIX #1 — Reset to page 1 when searching
  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery]);


  const handleCheckboxChange = (itemId, options, restaurantId, name) => {
    setSelectedItems((prevSelectedItems) => {
      const updatedItems = { ...prevSelectedItems };
      if (updatedItems[itemId]) {
        delete updatedItems[itemId];
      } else {
        updatedItems[itemId] = {
          optionId: options.length > 0 ? options[0].optionId : null,
          optionName: options.length > 0 ? options[0].name : null,
          quantity: 1,
          restaurantId: restaurantId,
          name: name,
        };
      }
      return updatedItems;
    });
    setRelatedItems((prevRelatedItems) =>
      prevRelatedItems.map((item) =>
        item._id === itemId ? { ...item, checked: !item.checked } : item
      )
    );
  };

  const handleRadioChange = (itemId, optionId, optionName) => {
    setSelectedItems((prevSelectedItems) => {
      const updatedItems = { ...prevSelectedItems };
      updatedItems[itemId] = {
        ...updatedItems[itemId],
        optionId,
        optionName,
        quantity: updatedItems[itemId]?.quantity || 1,
      };
      return updatedItems;
    });
  };

  const updateQuantity = (itemId, quantity) => {
    setSelectedItems((prevSelectedItems) => {
      const updatedItems = { ...prevSelectedItems };
      updatedItems[itemId].quantity = parseInt(quantity, 10) || 1;
      return updatedItems;
    });
  };

  const handleQuantityChange = (nameValObj) => {
    const [itemId, field] = nameValObj.name.split("_");
    updateQuantity(itemId, nameValObj.value);
  };

  const clearFields = () => {
    setSearchQuery("");
  };

  const handleOk = async () => {
    const comboMenuFoods = Object.entries(selectedItems).map(
      ([itemId, { name, optionId, optionName, quantity, restaurantId }]) => ({
        foodId: itemId,
        foodName: name,
        optionId: optionId,
        optionName: optionName,
        quantity: quantity,
        restaurantId: restaurantId,
      })
    );

    const params = {
      comboMenuFoods,
    };

    if (records.onFinish) {
      records.onFinish(params);
    }

    clearFields();
    records.onCancel();
  };

  const handleCancel = () => {
    clearFields();
    records.onCancel();
  };

  // 🔥 FIX #2 — Correct filter → then slice
  const filteredItems = relatedItems.filter((item) =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const slicedItems = filteredItems.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const totalFilteredItems = filteredItems.length;


  return (
    <Modal
      maskClosable={false}
      open={openModal}
      width={1024}
      okButtonProps={{
        style: {
          backgroundColor: "#FFD700",
          color: "#000000",
          fontFamily: "ubold",
        },
      }}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <div className="flex flex-col font-uregular">
        <div>
          {relatedItems.length > 0 && (
            <div className="flex flex-col mb-[12px]">
              <div className="flex justify-between items-center mb-4">
                <div className="text-lg font-bold">Food List</div>
                <Input
                  placeholder="Search Food"
                  style={{ width: 200, marginRight: 30 }}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
              <div className="space-y-4">
                {slicedItems.map((item) => (
                  <div key={item._id} className="flex items-start items-center border-b-2 pb-3 pr-3">
                    <div className="flex items-center" style={{ width: "30%" }}>
                      <ConfigProvider
                        theme={{
                          components: {
                            Button: {
                              defaultHoverBorderColor: "#FFD700",
                              defaultHoverColor: "#000000",
                              fontFamily: "ubold",
                            },
                          },
                          token: {
                            colorPrimary: "#FCBD10",
                          },
                        }}
                      >
                        <Checkbox
                          id={`item-checkbox-${item._id}`}
                          className="mr-3 rounded-full h-5 w-5"
                          onChange={() =>
                            handleCheckboxChange(
                              item._id,
                              item.options,
                              item.restaurantId,
                              item.name
                            )
                          }
                          checked={selectedItems[item._id] !== undefined}
                        />
                      </ConfigProvider>
                      <label
                        htmlFor={`item-checkbox-${item._id}`}
                        className="text-sm break-all"
                      >
                        {item.name}
                      </label>
                    </div>

                    <div
                      id={`options-${item._id}`}
                      className="flex flex-wrap justify-start"
                      style={{ width: "56%" }}
                    >
                      {item.options.map((option, optionIndex) => (
                        <div key={option._id} className={`pr-4 py-2 flex items-center ${option.name === 'System Default' ? 'invisible' : ''}`}>
                          <ConfigProvider
                            theme={{
                              components: {
                                Button: {
                                  defaultHoverColor: "#000000",
                                },
                              },
                              token: {
                                colorPrimary: "#FCBD10",
                              },
                            }}
                          >
                            <Radio
                              name={`item-options-${item._id}`}
                              id={`option-radio-${option.optionId}`}
                              className="peer mr-2 rounded-full h-4 w-4 break-all"
                              disabled={selectedItems[item._id] === undefined}
                              checked={
                                selectedItems[item._id]?.optionId ===
                                option.optionId ||
                                (selectedItems[item._id]?.optionId === null &&
                                  optionIndex === 0)
                              }
                              onChange={() =>
                                handleRadioChange(
                                  item._id,
                                  option.optionId,
                                  option.name
                                )
                              }
                            />
                          </ConfigProvider>
                          <label
                            htmlFor={`option-radio-${option.optionId}`}
                            className="text-sm max-w-xs break-all"
                          >
                            {option.name}
                          </label>
                        </div>
                      ))}
                    </div>

                    {selectedItems[item._id] !== undefined && (
                      <div
                        className="flex items-center space-x-2"
                        style={{ width: "100px" }}
                      >
                        <label className="text-sm">Qty:</label>
                        <CustomInputNumber
                          name={`${item._id}_qty`}
                          value={selectedItems[item._id]?.quantity || 1}
                          setValue={handleQuantityChange}
                          min={1}
                          max={99}
                          shouldSetValueSetObj={true}
                        />
                      </div>
                    )}
                  </div>
                ))}
              </div>

              <Divider />


              <div className="mb-3">
                <div>
                  <Pagination
                    showQuickJumper={false}
                    showSizeChanger={{ showSearch: false }}
                    current={currentPage}
                    pageSize={pageSize}
                    pageSizeOptions={[10, 20, 30, 40, 50, 100]}
                    total={totalFilteredItems}
                    onChange={(page, pageSize) => {
                      setCurrentPage(page);
                      setPageSize(pageSize);
                    }}
                  />
                </div>
              </div>

            </div>
          )}
        </div>
      </div>
    </Modal>
  );
}

export default AddSetFoodMenuModal;
